import { DeliveryBatchState } from '../enums/tasks';
import { IDeliveryBatch } from '../interfaces/delivery-company/tasks';

export const emptyDeliveryBatch: IDeliveryBatch = {
  id: '',
  status: DeliveryBatchState.ASSIGNED,
  branch: null,
  orders: [],
  driver: null,
  package_count: 0,
};
